
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-green-100">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl flex items-center justify-center">
                <i className="ri-music-2-line text-white text-xl"></i>
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
                  Salad Web App
                </h1>
                <p className="text-sm text-gray-600">Music discovery and community platform</p>
              </div>
            </div>
            
            <button
              onClick={() => navigate('/forum')}
              className="bg-gradient-to-r from-green-500 to-emerald-600 text-white px-6 py-2 rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all duration-200 font-medium cursor-pointer whitespace-nowrap flex items-center gap-2"
            >
              <i className="ri-discuss-line"></i>
              Join Forum
            </button>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/e62a2cbbe0ce6a8d7341c2c3c0f31b90.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-green-900/80 to-emerald-900/60"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 py-24">
          <div className="max-w-2xl">
            <h2 className="text-5xl font-bold text-white mb-6 leading-tight">
              Discover Music.<br />
              Connect with Community.
            </h2>
            <p className="text-xl text-green-100 mb-8 leading-relaxed">
              Join thousands of music lovers in synchronized listening sessions, discover new artists, and engage in meaningful discussions about the music that moves you.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => navigate('/forum')}
                className="bg-white text-green-600 px-8 py-4 rounded-lg hover:bg-green-50 transition-all duration-200 font-semibold cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                <i className="ri-discuss-line text-lg"></i>
                Explore Forum
              </button>
              <button className="border-2 border-white text-white px-8 py-4 rounded-lg hover:bg-white hover:text-green-600 transition-all duration-200 font-semibold cursor-pointer whitespace-nowrap flex items-center justify-center gap-2">
                <i className="ri-headphone-line text-lg"></i>
                Start Listening
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="max-w-7xl mx-auto px-4 py-20">
        <div className="text-center mb-16">
          <h3 className="text-3xl font-bold text-gray-900 mb-4">
            Everything You Need for Music Discovery
          </h3>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Our integrated platform combines listening sessions with community discussions for the ultimate music experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="bg-white rounded-xl shadow-sm border border-green-100 p-6 text-center hover:shadow-md transition-shadow duration-200">
            <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-headphone-line text-white text-2xl"></i>
            </div>
            <h4 className="text-lg font-semibold text-gray-900 mb-2">Listening Sessions</h4>
            <p className="text-gray-600 text-sm">
              Join synchronized listening experiences with detailed discussions and insights.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-green-100 p-6 text-center hover:shadow-md transition-shadow duration-200">
            <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-music-2-line text-white text-2xl"></i>
            </div>
            <h4 className="text-lg font-semibold text-gray-900 mb-2">Music Discovery</h4>
            <p className="text-gray-600 text-sm">
              Discover new artists and tracks through community recommendations and algorithms.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-green-100 p-6 text-center hover:shadow-md transition-shadow duration-200">
            <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-equalizer-line text-white text-2xl"></i>
            </div>
            <h4 className="text-lg font-semibold text-gray-900 mb-2">Equipment Reviews</h4>
            <p className="text-gray-600 text-sm">
              Get expert advice on audio equipment from experienced community members.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-green-100 p-6 text-center hover:shadow-md transition-shadow duration-200">
            <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-group-line text-white text-2xl"></i>
            </div>
            <h4 className="text-lg font-semibold text-gray-900 mb-2">Community</h4>
            <p className="text-gray-600 text-sm">
              Connect with like-minded music enthusiasts and build lasting friendships.
            </p>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-gradient-to-r from-green-500 to-emerald-600 py-20">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h3 className="text-3xl font-bold text-white mb-4">
            Ready to Join the Community?
          </h3>
          <p className="text-xl text-green-100 mb-8">
            Start your musical journey today and connect with thousands of music lovers worldwide.
          </p>
          <button
            onClick={() => navigate('/forum')}
            className="bg-white text-green-600 px-8 py-4 rounded-lg hover:bg-green-50 transition-all duration-200 font-semibold cursor-pointer whitespace-nowrap text-lg flex items-center justify-center gap-2 mx-auto"
          >
            <i className="ri-discuss-line text-xl"></i>
            Join Forum Now
          </button>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="col-span-1 md:col-span-2">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-emerald-600 rounded-lg flex items-center justify-center">
                  <i className="ri-music-2-line text-white text-lg"></i>
                </div>
                <span className="text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                  Salad Web App
                </span>
              </div>
              <p className="text-gray-400 mb-4">
                The ultimate platform for music discovery and community engagement.
              </p>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">Community</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Forum</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Sessions</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Events</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">Support</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Help Center</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Contact</a></li>
                <li><a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer">Website Builder</a></li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 Salad Web App. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
